<template>
    <div>
        <b-button :variant="variant" :class="className">{{ value }}</b-button>
    </div>
</template>

<script>
export default {
    name: 'Button',
    props: ['variant', 'className', 'value']
}
</script>

<style scoped>

</style>
